<script>
  export let id = -1;

  import Menu from "../components/Menu.svelte";
  import Breadcrumbs from "../components/Breadcrumbs.svelte";
  import Footer from "../components/Footer.svelte";
  import DialogChangePassword from "../components/DialogChangePassword.svelte";

  import { dictionary } from "../utils/stores.js";
  import { getToken, redirectIfNotToken } from "../utils/token.js";
  import { post } from "../utils/api.js";
  import { generateSign } from "../utils/signs";

  import { onMount } from "svelte";

  redirectIfNotToken("/login");

  let dict;

  const unsubscribe = dictionary.subscribe(value => {
    dict = value;
  });

  const pageName = "opciones";

  let passwd1 = "";
  let passwd2 = "";
  let email = "";
  let nombre = "";
  let apellido1 = "";
  let apellido2 = "";
  let institucion = "";
  let firma = "";
  let seleccionableRevisor = true;

  let divErrorEmail;
  let divErrorNombre;
  let divErrorApellido1;
  let divErrorInstitucion;
  let divErrorFirma;
  let divErrorTerminos;

  let errorMsg = "";
  let errorPasswdMsg = "";
  let okMsg = "";

  onMount(async () => {
    obtenerUsuario();
  });

  let obtenerUsuario = async () => {
    const response = await post(
      "PerfilUsuario",
      {
        token: getToken(),
        id
      },
      "json"
    );
    email = response.email;
    nombre = response.nombreUsuario;
    apellido1 = response.apellido1Usuario;
    apellido2 = response.apellido2Usuario;
    institucion = response.institucionUsuario;
    firma = response.firmaUsuario;
    seleccionableRevisor = response.seleccionableRevisor;
  };

  let changePassword = () => {
    post(
      "CambiarPassword",
      {
        token: getToken(),
        id,
        nuevaPassword: passwd1
      },
      null
    );
    passwd1 = "";
    passwd2 = "";
    errorPasswdMsg = "";
    errorMsg = "";
    okMsg = dict["passwordOK"];
    window.$("#changePassword").modal("hide");
  };

  let showDialogChangePassword = () => {
    passwd1 = "";
    passwd2 = "";
    errorPasswdMsg = "";
    window.$("#changePassword").modal("show");
  };

  let actualizarUsuario = e => {
    errorMsg = "";
    const error =
      nombre === "" ||
      apellido1 === "" ||
      institucion === "" ||
      firma === "" ||
      divErrorNombre.classList.contains("has-error") ||
      divErrorApellido1.classList.contains("has-error") ||
      divErrorInstitucion.classList.contains("has-error") ||
      divErrorFirma.classList.contains("has-error");
    if (!error) {
      e.preventDefault();
      post(
        "EditarPerfilUsuario",
        {
          token: getToken(),
          id,
          nombreUsuario: nombre,
          apellido1Usuario: apellido1,
          apellido2Usuario: apellido2,
          institucionUsuario: institucion,
          firmaUsuario: firma,
          seleccionableRevisor
        },
        null
      );
      okMsg = dict["usuarioActualizado"];
    }
  };
</script>

<style>
  div.form {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 45px;
  }

  div.formPasswd {
    margin-bottom: 40px;
  }
</style>

<div class="ie-panel">
  <a href="http://windows.microsoft.com/en-US/internet-explorer/">
    <img
      src="images/ie8-panel/warning_bar_0000_us.jpg"
      height="42"
      width="820"
      alt="You are using an outdated browser. For a faster, safer browsing
      experience, upgrade for free today." />
  </a>
</div>
<div class="preloader" id="loading">
  <div class="preloader-body">
    <div id="loading-center-object">
      <div class="object" id="object_four" />
      <div class="object" id="object_three" />
      <div class="object" id="object_two" />
      <div class="object" id="object_one" />
    </div>
  </div>
</div>
<div class="page">

  <!-- Menu -->

  <Menu {pageName} />

  <!-- Breadcrumbs -->

  <Breadcrumbs pageName={dict[pageName]} />

  <!-- Body -->

  <section class="section">
    <div class="container">
      <h3 class="titulo">{dict['configuracionCuenta']}</h3>
      <h3 class="titulo subtitulo">{email}</h3>
      <div class="form">
        <form
          class="rd-form rd-mailform"
          action=""
          method="post"
          on:submit={e => actualizarUsuario(e)}>
          {#if errorMsg !== ''}
            <div class="alert alert-danger" role="alert">{errorMsg}</div>
          {/if}
          {#if okMsg !== ''}
            <div class="alert alert-success" role="alert">{okMsg}</div>
          {/if}
          <div class="form-wrap" bind:this={divErrorNombre}>
            <input
              class="form-input"
              id="register-name"
              type="text"
              name="nombre"
              placeholder={dict['nombre']}
              data-constraints="@Required"
              bind:value={nombre} />
          </div>
          <div class="form-wrap" bind:this={divErrorApellido1}>
            <input
              class="form-input"
              id="register-lastname1"
              type="text"
              name="apellido1"
              placeholder={dict['apellido1']}
              data-constraints="@Required"
              bind:value={apellido1} />
          </div>
          <div class="form-wrap">
            <input
              class="form-input"
              id="register-lastname2"
              type="text"
              name="apellido2"
              placeholder={dict['apellido2']}
              bind:value={apellido2} />
          </div>
          <div class="form-wrap" bind:this={divErrorInstitucion}>
            <input
              class="form-input"
              id="register-institution"
              type="text"
              name="institucion"
              placeholder={dict['institucion']}
              data-constraints="@Required"
              bind:value={institucion} />
          </div>
          <div class="form-wrap" bind:this={divErrorFirma}>
            <input
              class="form-input"
              id="register-sign"
              type="text"
              name="firma"
              placeholder={dict['firma']}
              data-constraints="@Required"
              bind:value={firma}
              on:focus={() => {
                if (nombre !== '' && apellido1 !== '' && firma === '') {
                  firma = generateSign(nombre, apellido1);
                }
              }} />
          </div>
          <div class="form-wrap">
            <label class="form-check-label">
              <input
                type="checkbox"
                class="form-check-input"
                bind:checked={seleccionableRevisor} />
              {dict['proponermeRevisor']}
            </label>
          </div>
          <div class="send">
            <div class="form-wrap">
              <button
                class="button button-block button-primary button-shadow"
                type="submit">
                {dict['actualizar']}
              </button>
            </div>
          </div>
        </form>
      </div>
      <div class="form formPasswd">
        <form
          class="rd-form rd-mailform"
          action=""
          method="post"
          onload={obtenerUsuario()}>
          <div class="send">
            <div class="form-wrap">
              <div
                class="button button-lg button-primary"
                on:click={() => showDialogChangePassword()}>
                {dict['cambiarPassword']}
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </section>
  <Footer />
</div>
<div class="snackbars" id="form-output-global" />
<DialogChangePassword
  bind:passwd1
  bind:passwd2
  bind:errorMsg={errorPasswdMsg}
  onChangePassword={changePassword} />
